import { Link } from 'react-router-dom';

const fabricHighlights = [
  { icon: 'ri-global-line', label: 'Italian Wools', desc: 'Loro Piana, Ermenegildo Zegna, and Vitale Barberis Canonico — the world\'s finest suiting wools.' },
  { icon: 'ri-leaf-line', label: 'English Tweeds', desc: 'Classic Scottish and English wools from heritage mills. Character, warmth, and timeless style.' },
  { icon: 'ri-sun-line', label: 'Seasonal Linens', desc: 'Lightweight summer fabrics for warm-weather elegance that still looks sharp.' },
  { icon: 'ri-droplet-line', label: 'Cashmere Blends', desc: 'Luxuriously soft fibers for premium comfort, extraordinary drape, and refined texture.' },
  { icon: 'ri-contrast-line', label: 'Egyptian Cotton', desc: 'Ultra-fine long-staple cotton for custom shirts with an exceptional soft hand-feel.' },
  { icon: 'ri-shield-star-line', label: 'Performance Blends', desc: 'Wrinkle-resistant, travel-friendly fabrics for the modern executive who never stops moving.' },
];

const ServicesFabricSection = () => {
  return (
    <section className="py-32 bg-[#F9F6F0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-24 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden h-[600px]">
              <img
                src="https://public.readdy.ai/ai/img_res/31168bdee9b2b6d7a3ffecabcee4973a.jpg"
                alt="Premium fabric selection at Custom Clothiers — Italian and English suiting fabrics"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl p-6 border border-[#C4A962]/20 w-52 text-center">
              <p className="text-5xl font-bold text-[#C4A962] leading-none">5,000<span className="text-3xl">+</span></p>
              <p className="text-gray-600 text-sm mt-2 font-medium leading-tight">Premium Fabrics Available</p>
              <p className="text-gray-400 text-xs mt-1">From mills worldwide</p>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <p className="text-[#C4A962] font-semibold tracking-widest uppercase text-sm mb-5">
              The Materials
            </p>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Fabric &amp; Craftsmanship That Speaks for Itself
            </h2>
            <p className="text-gray-500 text-lg leading-relaxed mb-5">
              We source our fabrics from the world's most respected mills in Italy, England, and beyond.
              With over 5,000 fabric options available, clients enjoy a breadth of choice that
              no off-the-rack retailer can match — and a depth of quality that simply doesn't exist in mass production.
            </p>
            <p className="text-gray-500 text-lg leading-relaxed mb-12">
              Our master tailors bring 55+ years of hands-on experience to every garment — applying
              traditional bespoke construction techniques that deliver clothing that fits, moves,
              and lasts unlike anything you have ever worn.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
              {fabricHighlights.map((item) => (
                <div key={item.label} className="flex items-start gap-4 bg-white rounded-2xl p-5 border border-gray-100 hover:border-[#C4A962]/30 transition-all">
                  <div className="w-11 h-11 flex items-center justify-center bg-[#C4A962]/10 rounded-xl flex-shrink-0">
                    <i className={`${item.icon} text-[#C4A962] text-xl`}></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900 text-sm mb-1">{item.label}</p>
                    <p className="text-gray-500 text-xs leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <Link
              to="/contact"
              className="inline-flex items-center bg-[#C4A962] text-white px-8 py-4 rounded-xl font-semibold hover:bg-[#B39952] transition-colors whitespace-nowrap"
            >
              <i className="ri-palette-line mr-2"></i>
              View Our Fabric Selection
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesFabricSection;
